/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectList_itemSearch$ref = any;
export type SbSharedRefineMenuFilterPeriod_itemSearch$ref = any;
export type SbSharedRefineMenuFilterPeriod_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectList_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterPeriod_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterPeriod_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectList_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b53ed5e16fdfef2179e72500a89c77d7';
export default node;
